((InnerMenu, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.subLinks = $('.sublink');
    $dom.subNavOpen = $('.subnav');
    $dom.topLevelLink = $('[top-level-link]');
    $dom.activeLink =$('[active-link]');
    $dom.tagUrl = $('[data-link-tag]');
  }

  const openSubNav = () => {
    $dom.subNavOpen.removeClass('open');
    if($('.sublink-wrapper.active .sublink.active').length){
      $dom.subNavOpen.addClass('open');
    }
  }

  const tagLink = (event) => {
    const tagUrl = $(event.currentTarget).attr('href');
    $dom.subLinks.removeClass('active');
    $('.sublink-wrapper').removeClass('active');
    $('.subnav').removeClass('open');
    $dom.subLinks.each( function() {
      const $this = $(this);
      if($this.attr('href') == tagUrl){
        const baseUrl = tagUrl.split('/tagged')[0];
        const topLevelUrl = $('.top-level-link');
        $this.closest('.sublink-wrapper').addClass('active');
        $this.closest('.subnav').addClass('open');
        $this.addClass('active');

        $dom.topLevelLink.each(function (){
          const $link = $(this);
          if(baseUrl == $link.find('.top-level-link').attr('href')){
            $dom.topLevelLink.removeClass('active');
            const navTrigger = $link.attr('nav-trigger');
            $dom.topLevelLink.filter('[nav-trigger="'+ navTrigger + '"]').addClass('active');
          }
        })  
      }
    })
  }

  const updateScrollPosition = () => {
    const getCookie = Cookies.get('usersScollLocation');
    if(getCookie){
      $(window).scrollTop(getCookie);
       Cookies.remove('usersScollLocation')
    }
  }
  const bindUIActions = () => {

    $dom.tagUrl.on('click', (event) => {
      tagLink(event)
    });

    $(document).on('click','.blog-hero a',(event)=>{
      Cookies.set('usersScollLocation', $(window).scrollTop());
    })

    $dom.activeLink.on('click', () => {
      $('.link-items').toggleClass('hidden');
      $('.dropdown-arrow').toggleClass('rotate');
    });

    $dom.topLevelLink.on('click', (event) => {
      $('.link-items').toggleClass('hidden');
      $('.dropdown-arrow').toggleClass('rotate');
    });
  };

  InnerMenu.init = () => {
    cacheDom();
    bindUIActions();
    openSubNav();
    updateScrollPosition();

  }

})(window.InnerMenu = window.InnerMenu || {}, jQuery);